import fs from 'node:fs'
import path from 'node:path'
import { CONFIG_FILE_NAME } from '@cli-constants/paths.js'

export function findConfigFile(cwd: string): string | undefined {
  const filePath = path.join(cwd, CONFIG_FILE_NAME)
  return fs.existsSync(filePath) ? filePath : undefined
}
